import { IstatDataService } from "./../servizi/istat-data.service";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, ValidationErrors } from "@angular/forms";
import { MappaService } from "src/app/servizi/mappa/mappa.service";
import { GestioneLoginService } from "../servizi/login/gestione-login.service";
import {
  faMapMarker,
  faSearch,
  faEdit,
  faTrashAlt,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { ConfigService } from "../servizi/config/config.service";
import { ListComponent } from "../library/ebw-list-angular/list.component";
import { AnalysisUtilsService } from "../mappa/right-sidebar/analysis-utils.service";
import { GestioneUtentiService } from "../servizi/utenti/gestione-utenti.service";
import { Observable, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, map, tap } from "rxjs/operators";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { GroupsHandlerService } from "../servizi/groups-handler.service";

import * as _ from "lodash";
import { AnalysisDataAccessService } from "../servizi/analysis/analysis-data-access.service";
import { EbwModalService } from "../library/ebw-modals-angular/ebw-modal.service";
import { AnalysisPropertyModalComponent } from "../analysis/analysis-property-modal/analysis-property-modal.component";
import { Polygon } from "ol/geom";
import { AnalysisDataLoaderService } from "../servizi/analysis/analysis-data-loader.service";

import * as FileSaver from "file-saver";

@Component({
  selector: "app-ricerca-analisi",
  templateUrl: "./ricerca-analisi.component.html",
  styleUrls: ["./ricerca-analisi.component.scss"],
})

// IMPROVEMENTS: Illuminzazione tasti menù laterale sx
export class RicercaAnalisiComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public EPSG_CODE_1 = 4326;
  public EPSG_CODE_2 = 3857;

  public SRID_1 = `SRID=${this.EPSG_CODE_1};`;
  public EPSG_1 = `EPSG:${this.EPSG_CODE_1}`;
  public EPSG_2 = `EPSG:${this.EPSG_CODE_2}`;

  // Limita i risultati degli autocomplete
  private SLICE_ROWS = 10;

  /** Componente lista */
  @ViewChild("listComponent", { static: false }) listComponent: ListComponent;

  ready = false;

  filterForm: FormGroup;
  token: string;

  listType = "analysis_user_group"; // values: analysis_user_group || no_pagination (per visualizzazione marker)
  listChangedTrigger = 0;
  listParamsFilters = [];
  rowsPerPageOptions = [10, 25, 50, 100];

  // Risultati restituiti dalla lista e visualizzati
  listResults = [];

  // API analisi utente/gruppo utente loggato
  restApiPath = this.configService.getConfigListaAnalisi().search.analysis.url;
  listFields =
    this.configService.getConfigListaAnalisi().search.analysis.fields;

  /** Icone delle actions della lista */
  icons = {
    faMapMarker: faMapMarker,
    faSearch: faSearch,
    faEdit: faEdit,
    faTrashAlt: faTrashAlt,
    faPlusCircle: faPlusCircle,
  };

  layerVisibilityBeforeChange: boolean;

  groups = [];
  user;

  analysesFeatureInfo = [];

  // Autocomplete: group
  groupsTypehead = [];
  // Autocomplete: nome_sito
  nomeSitoTypehead = [];
  // Autocomplete: piano_lavori
  pianoLavoriTypehead = [];

  // Autocomplete: istat_elenco_comuni
  // Relazioni
  istatElencoComuniTypehead = [];
  // Valori
  comuni = [];

  // Autocomplete: istat_elenco_comuni --> regioni
  // Relazioni
  istatElencoComuniTypehead_regioni;
  // Valori
  province = [];

  // Autocomplete: istat_elenco_comuni --> province
  // Relazioni
  istatElencoComuniTypehead_province;
  // Valori
  regioni = [];

  // Per filtrare per user OR group
  orConditions = {
    or: [],
  };

  // Id delle analisi da visualizzare (no paginazione)
  analysesMarkerIds = [];

  mapReadySub: Subscription;

  // Per inizializzare i gruppi e poi far partire la ricerca
  // Solo quando i filtri su gruppo dell'utente loggato e utente sono pronti faccio partire la ricerca
  paramsInit = false;

  arrayChipsComuni = [];
  arrayChipsProvince = [];
  arrayChipsRegioni = [];
  arrayChipsPianoLavori = [];
  arrayChipsGroups = [];

  constructor(
    private mappaService: MappaService,
    private gestioneLoginService: GestioneLoginService,
    private configService: ConfigService,
    private analysisUtilsService: AnalysisUtilsService,
    private gestioneUtentiService: GestioneUtentiService,
    private groupService: GroupsHandlerService,
    private istatDataService: IstatDataService,
    private analysisDataAccessService: AnalysisDataAccessService,
    private ebwModalService: EbwModalService,
    private modalService: NgbModal,
    private analysisDataLoaderService: AnalysisDataLoaderService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getIstatElencoComuni();

    // Gruppi associati all'utente
    this.gestioneUtentiService.userData.groups.forEach((group) => {
      this.groups.push(group.id);
    });

    // Utente
    this.user = this.gestioneUtentiService.userData.id;

    // Recupero solo i gruppi associati all'utente loggato per popolare l'Autocomplete
    this.getGroups();

    // // Recupero i Piani Lavoro disponibili nel db
    // this.getPianoLavori();

    // Recupero il token associato al'utente loggato
    this.token = this.gestioneLoginService.getToken();

    // Ridimensionamento sidebar mappa
    this.mappaService.setRightSidebarWidthSubject.next("large");

    // Inizializzazione Form dei Filtri
    this.initializeForm();

    // Inizializzazione Lista
    this.initList();
  }

  ngAfterViewInit(): void {
    this.mapReadySub = this.mappaService.mapReady.subscribe((isReady) => {
      if (isReady) {
        setTimeout(() => {
          this.layerVisibilityBeforeChange =
            this.mappaService.cambiaVisibilitaLayer("AnalysisAreas", true);
          // Pulire il layer + Posizionamento su Roma + Zoom
          this.analysisUtilsService.showAreasOnMap(null);
        }, 0);
      }
    });

    // Recupero i Piani Lavoro disponibili nel db
    this.getPianoLavori();
  }

  ngOnDestroy() {
    // Ripristino dimensioni sidebar mappa
    this.mappaService.setRightSidebarWidthSubject.next("small");

    // Ripristino la visibilità del layer analisi
    this.mappaService.cambiaVisibilitaLayer(
      "AnalysisAreas",
      this.layerVisibilityBeforeChange
    );

    if (this.mapReadySub) {
      this.mapReadySub.unsubscribe();
    }
  }

  initList() {
    // Per vedere le analisi associate al gruppo dell'utente...
    if (!!this.groups) {
      this.orConditions.or.push({
        field: "rel_analysis_group.group_id",
        in: this.groups,
      });
    }

    // O dell'utente stesso
    if (!!this.user) {
      this.orConditions.or.push({
        field: "rel_analysis_group.user_id",
        eq: this.user,
      });
    }

    this.listParamsFilters.push(this.orConditions);

    this.paramsInit = true;
  }

  initializeForm() {
    this.filterForm = new FormGroup(
      {
        nome_sito: new FormControl(null),
        piano_lavori: new FormControl(null),
        anno_piano_lavori: new FormControl(null),
        sr: new FormControl(null),
        altezza_centro_elettrico_min: new FormControl(null),
        altezza_centro_elettrico_max: new FormControl(null),
        raggio_area_di_ricerca_min: new FormControl(null),
        raggio_area_di_ricerca_max: new FormControl(null),
        codice_cliente_1: new FormControl(null),
        codice_cliente_2: new FormControl(null),
        codice_cliente_3: new FormControl(null),
        gruppo: new FormControl(null),
        comune: new FormControl(null),
        provincia: new FormControl(null),
        regione: new FormControl(null),
      },
      [this.atLeastOneValue]
    );

    this.ready = true;
  }

  // ** Autocomplete Nome Sito
  searchNomeSito = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap((x) => console.log("typed: ", x)),
      map(
        (term) =>
          term.length < 2
            ? this.nomeSitoTypehead
            : this.nomeSitoTypehead
                .filter((item) => {
                  return item.toLowerCase().includes(term.toLowerCase());
                })
                .slice(0, this.SLICE_ROWS) // Limita i risultati
      )
    );

  ngbTypeaheadResultFormatterNomeSito(item: any) {
    return item;
  }
  onSelectedNomeSito(event: NgbTypeaheadSelectItemEvent) {
    console.log("selected item", event);
    // this.currentGroup = event.item;
  }

  // ** Autocomplete Gruppo
  searchGroup = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap((x) => console.log("typed: ", x)),
      map(
        (term) =>
          term.length < 2
            ? this.groupsTypehead
            : this.groupsTypehead
                .filter((item) => {
                  return item.name.toLowerCase().includes(term.toLowerCase());
                })
                .slice(0, this.SLICE_ROWS) // Limita i risultati
      )
    );

  ngbTypeaheadResultFormatterGroup(item: any) {
    return item.name;
  }

  onSelectedGroup(event: NgbTypeaheadSelectItemEvent) {
    this.addChipsGroups(event.item);
  }

  getGroups() {
    this.groupService.groupListOfLoggedUser({ user: this.user }).subscribe({
      next: (res) => {
        // to do check if error
        if (res && res.data && res.data.length > 0) {
          this.groupsTypehead = res.data.map((x) => x.properties);
        }
      },
    });
  }

  // @author Giulia Briscolini
  // ** Autocomplete PianoLavori
  searchPianoLavori = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap((x) => console.log("typed: ", x)),
      map((term) =>
        term.length < 2
          ? this.pianoLavoriTypehead
          : this.pianoLavoriTypehead
            .filter((item) => {
              return item.name.toLowerCase().includes(term.toLowerCase());
            })
            .slice(0, this.SLICE_ROWS) // Limita i risultati
      )
    );

  ngbTypeaheadResultFormatterPianoLavori(item: any) {
    return item.name;
  }
  onSelectedPianoLavori(event: NgbTypeaheadSelectItemEvent) {
    this.addChipsPianoLavori(event.item.name);
  }

  getPianoLavori() {
    const params = {
      dbField: "piano_lavori",
    };

    this.analysisDataAccessService.getAutocompleteData(params).subscribe({
      next: (res) => {
        if (res.error == 0 && !!res.data) {
          this.pianoLavoriTypehead = res.data;
        }
      },
    });
  }

  // ** Autocomplete Comune
  searchComune = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap((x) => console.log("typed: ", x)),
      map(
        (term) =>
          term.length < 1
            ? this.comuni
            : this.comuni
                .filter((item) => {
                  return item.toLowerCase().includes(term.toLowerCase());
                })
                .slice(0, this.SLICE_ROWS) // Limita i risultati
      )
    );

  ngbTypeaheadResultFormatterComune(item: any) {
    return item;
  }
  onSelectedComune(event: NgbTypeaheadSelectItemEvent) {
    this.addChipsComuni(event.item);

    // Il comune è contenuto nella provincia?
    if (
      !!this.filterForm.get("provincia").value &&
      this.filterForm.get("provincia").value.trim() !== ""
    ) {
      this.checkIstatData(event, "comune", "provincia", false);
    }

    // Il comune è contenuto nella regione?
    if (
      !!this.filterForm.get("regione").value &&
      this.filterForm.get("regione").value.trim() !== ""
    ) {
      this.checkIstatData(event, "comune", "regione", false);
    }
    this.empty("comune");
  }

  // ** Autocomplete Provincia
  searchProvincia = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap((x) => console.log("typed: ", x)),
      map(
        (term) =>
          term.length < 1
            ? this.province
            : this.province
                .filter((item) => {
                  return item.toLowerCase().includes(term.toLowerCase());
                })
                .slice(0, this.SLICE_ROWS) // Limita i risultati
      )
    );

  ngbTypeaheadResultFormatterProvincia(item: any) {
    return item;
  }
  onSelectedProvincia(event: NgbTypeaheadSelectItemEvent) {
    this.addChipsProvince(event.item);
    // La provincia è contenuta nella regione?
    if (
      !!this.filterForm.get("regione").value &&
      this.filterForm.get("regione").value.trim() !== ""
    ) {
      this.checkIstatData(event, "provincia", "regione", false);
    }

    // La provincia contiene il comune?
    if (
      !!this.filterForm.get("comune").value &&
      this.filterForm.get("comune").value.trim() !== ""
    ) {
      this.checkIstatData(event, "comune", "provincia", true);
    }

    this.empty("provincia");
  }

  // ** Autocomplete Regione
  searchRegione = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap((x) => console.log("typed: ", x)),
      map(
        (term) =>
          term.length < 1
            ? this.regioni
            : this.regioni
                .filter((item) => {
                  return item.toLowerCase().includes(term.toLowerCase());
                })
                .slice(0, this.SLICE_ROWS) // Limita i risultati
      )
    );

  ngbTypeaheadResultFormatterRegione(item: any) {
    return item;
  }
  onSelectedRegione(event: NgbTypeaheadSelectItemEvent) {
    console.log(event.item);
    this.addChipsRegioni(event.item);
    // La regione contiene il comune?
    if (
      !!this.filterForm.get("comune").value &&
      this.filterForm.get("comune").value.trim() !== ""
    ) {
      this.checkIstatData(event, "comune", "regione", true);
    }

    // La regione contiene la provincia?
    if (
      !!this.filterForm.get("provincia").value &&
      this.filterForm.get("provincia").value.trim() !== ""
    ) {
      this.checkIstatData(event, "provincia", "regione", true);
    }
    this.empty("regione");
  }

  getIstatElencoComuni() {
    this.istatDataService.istatElencoComuniList().subscribe({
      next: (res) => {
        // to do check if error
        if (res && res.data && res.data.length > 0) {
          this.istatElencoComuniTypehead = res.data; // all
          this.comuni = this.istatElencoComuniTypehead.map(
            (x) => x.denominazione
          );

          this.istatElencoComuniTypehead_regioni = _.groupBy(
            res.data,
            "denominazione_regione"
          );
          this.regioni = Object.keys(this.istatElencoComuniTypehead_regioni);

          this.istatElencoComuniTypehead_province = _.groupBy(
            res.data,
            "denominazione_provincia"
          );
          this.province = Object.keys(this.istatElencoComuniTypehead_province);
        }
      },
    });
  }

  // Applica Filtri
  onSubmit() {
    this.listParamsFilters = [];
    this.analysesMarkerIds = [];

    // Filter by user or groups
    // this.listParamsFilters.push(this.orConditions);

    // "eq || ne || like || in || in_string || gt || mt || between": "todo"
    if (
      !!this.filterForm.value.nome_sito &&
      this.filterForm.value.nome_sito.trim() != ""
    ) {
      this.listParamsFilters.push({
        field: "nome_sito",
        like: this.filterForm.value.nome_sito,
      });
    }

    // Se è stato inserito un semplice testo e non ci sono chips (1 valore come prima)
    // if (this.arrayChipsPianoLavori.length === 0) {
    //   if (
    //     !!this.filterForm.value.piano_lavori &&
    //     this.filterForm.value.piano_lavori.trim() != ""
    //   ) {
    //     this.listParamsFilters.push({
    //       field: "piano_lavori",
    //       like: this.filterForm.value.piano_lavori,
    //     });
    //   }
    // }
    // // Altrimenti, se sono state inserite le chips, prendere quelle (Più valori con le chips)
    // else {
    if (this.arrayChipsPianoLavori.length > 0) {
      this.listParamsFilters.push({
        field: "piano_lavori",
        in_string: this.arrayChipsPianoLavori,
      });
    }
    //}

    if (
      !!this.filterForm.value.anno_piano_lavori &&
      this.filterForm.value.anno_piano_lavori.trim() != ""
    ) {
      this.listParamsFilters.push({
        field: "anno_piano_lavori",
        like: this.filterForm.value.anno_piano_lavori,
      });
    }

    if (!!this.filterForm.value.sr && this.filterForm.value.sr.trim() != "") {
      this.listParamsFilters.push({
        field: "sr",
        like: this.filterForm.value.sr,
      });
    }

    if (
      !!this.filterForm.value.codice_cliente_1 &&
      this.filterForm.value.codice_cliente_1.trim() != ""
    ) {
      this.listParamsFilters.push({
        field: "codice_cliente_1",
        like: this.filterForm.value.codice_cliente_1,
      });
    }

    if (
      !!this.filterForm.value.codice_cliente_2 &&
      this.filterForm.value.codice_cliente_2.trim() != ""
    ) {
      this.listParamsFilters.push({
        field: "codice_cliente_2",
        like: this.filterForm.value.codice_cliente_2,
      });
    }

    if (
      !!this.filterForm.value.codice_cliente_3 &&
      this.filterForm.value.codice_cliente_3.trim() != ""
    ) {
      this.listParamsFilters.push({
        field: "codice_cliente_3",
        like: this.filterForm.value.codice_cliente_3,
      });
    }

    // NEW
    // Groups Autocomplete
    // Nell'autocomplete sono visibili solo i gruppi associati all'utente loggato
    // if (this.arrayChipsGroups.length > 0) {
    //   const arrayChipsGroupsIds = this.arrayChipsGroups.map(el => el.id);
    //   this.listParamsFilters.push({
    //     field: "rel_analysis_group.group_id",
    //     in: arrayChipsGroupsIds,
    //   });
    // } 

    this.orConditions.or = [];

    if (this.arrayChipsGroups.length > 0) {
      const arrayChipsGroupsIds = this.arrayChipsGroups.map(el => el.id);
      this.orConditions.or.push({
        field: "rel_analysis_group.group_id",
        in: arrayChipsGroupsIds,
      });
    } 
    // Se il filtro non è stato usato, uso tutti i gruppi dell'utente loggato
    else if (!!this.groups) {
      this.orConditions.or.push({
        field: "rel_analysis_group.group_id",
        in: this.groups,
      });
    }

    // O dell'utente stesso
    if (!!this.user) {
      this.orConditions.or.push({
        field: "rel_analysis_group.user_id",
        eq: this.user,
      });
    }
    this.listParamsFilters.push(this.orConditions);
    

    // if (!!this.filterForm.value.comune && this.filterForm.value.comune.trim() != '') {
    if (this.arrayChipsComuni.length > 0) {
      this.listParamsFilters.push({
        field: "comune",
        //in: this.arrayChipsComuni
        // Array di stringhe di cui fare l'escape
        in_string: this.arrayChipsComuni,
      });
    }

    // if (!!this.filterForm.value.provincia && this.filterForm.value.provincia.trim() != '') {
    if (this.arrayChipsProvince.length > 0) {
      this.listParamsFilters.push({
        field: "provincia",
        //in: this.arrayChipsProvince
        // Array di stringhe di cui fare l'escape
        in_string: this.arrayChipsProvince,
      });
    }

    // if (!!this.filterForm.value.regione && this.filterForm.value.regione.trim() != '') {
    if (this.arrayChipsRegioni.length > 0) {
      this.listParamsFilters.push({
        field: "regione",
        //in: this.arrayChipsRegioni
        // Array di stringhe di cui fare l'escape
        in_string: this.arrayChipsRegioni,
      });
    }

    if (
      (!!this.filterForm.value.altezza_centro_elettrico_min ||
        this.filterForm.value.altezza_centro_elettrico_min === 0) &&
      (!!this.filterForm.value.altezza_centro_elettrico_max ||
        this.filterForm.value.altezza_centro_elettrico_max === 0)
    ) {
      this.listParamsFilters.push({
        field: "altezza_centro_elettrico_m",
        between: [
          this.filterForm.value.altezza_centro_elettrico_min,
          this.filterForm.value.altezza_centro_elettrico_max,
        ],
      });
    } else if (
      !!this.filterForm.value.altezza_centro_elettrico_min ||
      this.filterForm.value.altezza_centro_elettrico_min === 0
    ) {
      this.listParamsFilters.push({
        field: "altezza_centro_elettrico_m",
        gt: this.filterForm.value.altezza_centro_elettrico_min,
      });
    } else if (
      !!this.filterForm.value.altezza_centro_elettrico_max ||
      this.filterForm.value.altezza_centro_elettrico_max === 0
    ) {
      this.listParamsFilters.push({
        field: "altezza_centro_elettrico_m",
        mt: this.filterForm.value.altezza_centro_elettrico_max,
      });
    }

    if (
      (!!this.filterForm.value.raggio_area_di_ricerca_min ||
        this.filterForm.value.raggio_area_di_ricerca_min === 0) &&
      (!!this.filterForm.value.raggio_area_di_ricerca_max ||
        this.filterForm.value.raggio_area_di_ricerca_max === 0)
    ) {
      this.listParamsFilters.push({
        field: "raggio_area_di_ricerca_m",
        between: [
          this.filterForm.value.raggio_area_di_ricerca_min,
          this.filterForm.value.raggio_area_di_ricerca_max,
        ],
      });
    } else if (
      !!this.filterForm.value.raggio_area_di_ricerca_min ||
      this.filterForm.value.raggio_area_di_ricerca_min === 0
    ) {
      this.listParamsFilters.push({
        field: "raggio_area_di_ricerca_m",
        gt: this.filterForm.value.raggio_area_di_ricerca_min,
      });
    } else if (
      !!this.filterForm.value.raggio_area_di_ricerca_max ||
      this.filterForm.value.raggio_area_di_ricerca_max === 0
    ) {
      this.listParamsFilters.push({
        field: "raggio_area_di_ricerca_m",
        mt: this.filterForm.value.raggio_area_di_ricerca_max,
      });
    }

    // Usare l'API getElenco della ebw-list senza paginazione per tirare fuori tutti gli id e le aree delle analisi filtrate
    // (ebw-list normale tira fuori i dati paginati per visualizzarli nella lista, per i marker invece devo tirare fuori tutto)
    let params = {
      select: "no_pagination",
      dbFields:
        "analysis.id AS analysis_id, analysis.nome_sito, analysis.area AS area",
      dbFieldsForGroupBy: "analysis.id, analysis.area",
      filterBy: this.listParamsFilters,
      orderBy: [{ field: "analysis.id", order: "desc" }],
    };

    console.log(this.listParamsFilters);

    if (this.listParamsFilters.length > 0) {
      // Trigger aggiornamento parametri iniziali lista
      setTimeout(
        () => (this.listChangedTrigger = this.listChangedTrigger + 1),
        0
      );

      this.analysisDataAccessService.analysisGetElenco(params).subscribe({
        next: (res) => {
          let analysesToShow = res.results;
          this.analysisUtilsService.showAreasOnMap(analysesToShow);
        },
      });
    } else {
      this.ebwModalService.openWarningModal({
        title: "Attenzione",
        content: "Popolare almeno un filtro.",
      });
    }
  }

  /** Reset Form Filtri e Lista */
  onReset() {

    this.paramsInit = false; // NEW
    this.orConditions.or = [];

    this.filterForm.reset();
    this.listParamsFilters = [];
    this.arrayChipsComuni = [];
    this.arrayChipsProvince = [];
    this.arrayChipsRegioni = [];
    this.arrayChipsPianoLavori = [];
    this.arrayChipsGroups = [];

    // Pulire il layer
    this.analysisUtilsService.showAreasOnMap(null);

    // Ripristinare il filtro per utente e gruppi dell'utente
    this.initList();

    setTimeout(
      () => (this.listChangedTrigger = this.listChangedTrigger + 1),
      0
    );

    
  }

  // Pressione bottone Action
  onAction(evt: { action: string; rowId: string }) {
    switch (evt.action) {
      case "callView":
        this._onCallView(evt.rowId);
        break;
      case "callPosizionamento":
        this._onCallPosizionamento(evt.rowId);
        break;
      default:
        console.log("onAction ---> ", evt);
        break;
    }
  }

  // Caricamento lista avvenuto
  onListLoaded(evt) {}

  // Valori lista caricati
  onListValues(analyses) {}

  /** Controlla se la provincia|regione selezionata contiene il comune|provincia (reverse:true)
   * o se il comune|provincia è contenuto nella provincia|regione (reverse:false)
   * event.item: valore appena selezionato
   * what: comune | provincia
   * where: provincia | regione
   * reverse:
   *  --> FALSE es. devo controllare se il comune selezionato è contenuto nella regione
   *  --> TRUE es. devo controllare se la regione selezionata contiene il comune
   */
  checkIstatData(event, what, where, reverse) {
    let istatArray;
    let istatField;
    let typeheadField;
    let typeheadArray;
    let fieldToCheck;
    let toReset;

    if (reverse) {
      typeheadField = event.item;
      fieldToCheck = this.filterForm.get(what).value;
      toReset = what;
    } else {
      typeheadField = this.filterForm.get(where).value;
      fieldToCheck = event.item;
      toReset = where;
    }

    // WHAT - Contenuto
    switch (what) {
      // Comune in...
      case "comune":
        istatField = "denominazione";
        break;

      // Provincia in...
      case "provincia":
        istatField = "denominazione_provincia";
        break;
    }

    // WHERE - Contenitore
    switch (where) {
      // ...Regione
      case "regione":
        typeheadArray = this.istatElencoComuniTypehead_regioni;
        break;

      // ...Provincia
      case "provincia":
        typeheadArray = this.istatElencoComuniTypehead_province;
        break;
    }

    istatArray = typeheadArray[typeheadField];

    if (!!istatArray && istatArray.length > 0) {
      let foundObj = istatArray.find((el) => el[istatField] === fieldToCheck);

      // Elemento non trovato
      if (!foundObj) {
        this.filterForm.get(toReset).reset();
      }
    } else {
      this.filterForm.get(toReset).reset();
    }
  }

  public atLeastOneValue(form: FormGroup): ValidationErrors {
    return Object.keys(form.value).some(
      (key) => !!form.value[key] || form.value[key] === 0
    )
      ? null
      : { atLeastOneRequired: "Almeno un campo deve essere valorizzato" };
  }

  private _onCallPosizionamento(analysisId: string) {
    this.analysisDataAccessService.getAnalysis(analysisId).subscribe({
      next: (res) => {
        if (res && res.error !== 0) {
          this.ebwModalService.openErrorModal({
            title: "Errore",
            content: res.errorDescription,
          });
          return;
        }
        const analysis = res.data[0];

        if (analysis.area?.type == "Polygon" && analysis.area?.coordinates) {
          const polygon = new Polygon(analysis.area.coordinates).transform(
            this.EPSG_1,
            this.EPSG_2
          ) as Polygon;

          this.analysisDataLoaderService.broadcastAnalysisGeometry(polygon);
        }
      },
      error: (error) => {
        this.ebwModalService.openErrorModal({
          title: "Errore",
          content: "Errore durante recupero dati analisi",
        });
      },
    });
  }

  private _onCallView(analysisId: string) {
    this.analysisDataAccessService.getAnalysis(analysisId).subscribe({
      next: (res) => {
        if (res && res.error !== 0) {
          this.ebwModalService.openErrorModal({
            title: "Errore",
            content: res.errorDescription,
          });
          return;
        }

        let analysisModal = this.modalService.open(
          AnalysisPropertyModalComponent,
          { ariaLabelledBy: "modal-basic-title", size: "l" }
        );
        const tempData = res.data[0];
        tempData["name"] = res.data[0].nome_sito;

        analysisModal.componentInstance.data = tempData;
      },
      error: (error) => {
        this.ebwModalService.openErrorModal({
          title: "Errore",
          content: "Errore durante recupero dati analisi",
        });
      },
    });
  }

  onCallExport() {
    let params = {
      select: "no_pagination",
      dbFields: `
        analysis.id AS id, 
        analysis.nome_sito, 
        analysis.piano_lavori, 
        analysis.anno_piano_lavori, 
        analysis.colore, analysis.sr, 
        analysis.codice_cliente_1,
        analysis.codice_cliente_2,
        analysis.codice_cliente_3,
        analysis.regione,
        analysis.provincia,
        analysis.comune,
        analysis.altezza_centro_elettrico_m,
        analysis.raggio_area_di_ricerca_m
        `,
      dbFieldsForGroupBy: "analysis.id",
      filterBy: this.listParamsFilters,
      orderBy: [{ field: "analysis.id", order: "desc" }],
    };

    this.analysisDataAccessService.exportCsv(params).subscribe({
      next: (data) => {
        const downloadURL = window.URL.createObjectURL(data);
        FileSaver.saveAs(
          downloadURL,
          `analisi_${new Date().toISOString()}.csv`
        );
      },
      error: (error) => {
        this.ebwModalService.openErrorModal({
          title: "Errore",
          content: "Errore preparazione export",
        });
      },
    });
  }
  //gestioni chips
  //regioni

  addChipsRegioni(chip: string) {
    this.deleteChipsRegioni(chip);
    this.arrayChipsRegioni.push(chip);
    this.arrayChipsComuni = [];
    this.arrayChipsProvince = [];
  }
  deleteChipsRegioni(chip) {
    this.arrayChipsRegioni = this.arrayChipsRegioni.filter(
      (ele: string) => ele != chip
    );
  }

  //provincia
  addChipsProvince(chip: string) {
    this.deleteChipsProvince(chip);
    this.arrayChipsProvince.push(chip);
    this.arrayChipsRegioni = [];
    this.arrayChipsComuni = [];
  }
  deleteChipsProvince(chip) {
    this.arrayChipsProvince = this.arrayChipsProvince.filter(
      (ele: string) => ele != chip
    );
  }

  //comune
  addChipsComuni(chip: string) {
    this.deleteChipsComuni(chip);
    this.arrayChipsComuni.push(chip);
    this.arrayChipsRegioni = [];
    this.arrayChipsProvince = [];
  }
  deleteChipsComuni(chip) {
    this.arrayChipsComuni = this.arrayChipsComuni.filter(
      (ele: string) => ele != chip
    );
  }

  /**
   * Svuota gli autocomplete
   * @param idForm
   */
  empty(idForm) {
    setTimeout(() => {
      this.filterForm.get(idForm).reset();
    }, 0);
  }

  // @author Giulia Briscolini
  addChipsPianoLavori(chip: string) {
    // Verifica se il nuovo chip è valido e non è già presente nell'array
    if (chip && !this.arrayChipsPianoLavori.includes(chip)) {
      this.arrayChipsPianoLavori.push(chip);
      this.empty("piano_lavori"); // Resetta il campo di input
    }
  }

  deleteChipsPianoLavori(chip) {
    this.arrayChipsPianoLavori = this.arrayChipsPianoLavori.filter(
      (el: string) => el != chip
    );
  }

  addChipsGroups(chip: string) {
    // Verifica se il nuovo chip è valido e non è già presente nell'array
    if (chip && !this.arrayChipsGroups.includes(chip)) {
      this.arrayChipsGroups.push(chip);
      this.empty("gruppo"); // Resetta il campo di input
    }
  }

  deleteChipsGroups(chip) {
    console.log("TEST deleteChipsGroups")
    this.arrayChipsGroups = this.arrayChipsGroups.filter(
      (el) => el.id != chip.id
    );
  }
}
